<template>
  <OverlayFrame
    :zIndex="overlayZIndex"
    :title="title"
    :subtitle="subtitle"
    :icon="icon"
    :closeOnScrim="closeOnScrim"
    @close="emit('close')"
  >
    <div class="stack">
      <div v-if="body" class="text-muted">{{ body }}</div>
      <div class="actions">
        <UiButton variant="secondary" size="sm" @click="emit('cancel')">{{ cancelLabel }}</UiButton>
        <UiButton :variant="variant === 'danger' ? 'danger' : 'primary'" size="sm" @click="emit('confirm')">
          {{ confirmLabel }}
        </UiButton>
      </div>
    </div>
  </OverlayFrame>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { ICONS } from "../../lib/icons";
import OverlayFrame from "./OverlayFrame.vue";
import UiButton from "../ui/UiButton.vue";

const props = withDefaults(
  defineProps<{
    overlayZIndex?: number;
    variant?: "default" | "danger";
    title: string;
    subtitle?: string | null;
    body?: string | null;
    confirmLabel?: string;
    cancelLabel?: string;
    closeOnScrim?: boolean;
  }>(),
  {
    overlayZIndex: 4200,
    variant: "default",
    subtitle: null,
    body: null,
    confirmLabel: "Confirm",
    cancelLabel: "Cancel",
    closeOnScrim: true
  }
);

const emit = defineEmits<{
  close: [];
  cancel: [];
  confirm: [];
}>();

const icon = computed(() => (props.variant === "danger" ? ICONS.states.danger : ICONS.states.warning));
</script>

<style scoped>
.actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.6rem;
  flex-wrap: wrap;
  margin-top: 0.25rem;
}
</style>

